'use client';

import { useState, useEffect } from 'react';
import { BurgerMenu, DesktopMenuLinks, MobileMenuLinks, Logo } from '..';
import Link from 'next/link';
import { HiPhone } from 'react-icons/hi';
import { phoneNumber } from '@/lib/data';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    document.addEventListener('scroll', () => {
      setHasScrolled(window.scrollY > 0 ? true : false);
    });
  });

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="z-50 bg-secondary-light/80 backdrop-blur-lg flex justify-between items-center h-16 rounded-full w-[80%] fixed top-0 left-1/2 -translate-x-1/2 py-10 md:px-6 px-3 md:mt-8 mt-4 shadow-lg">
      {/* Logo */}
      <Logo />
      {/* Desktop Menu */}
      <DesktopMenuLinks />
      <Link
        className="hidden font-lato font-bold lg:flex group text-xl text-white bg-linear-to-r from-cta-100 to-cta-100/75 hover:from-cta-100/75 hover:to-cta-100 uppercase transition-colors duration-300 p-3 rounded-3xl shadow-sm flex-row items-center gap-2"
        href={`tel:${phoneNumber}`}
        id='prenota_ora_navbar'>
        <HiPhone className="text-xl group-hover:animate-shake" />
        Prenota Ora
      </Link>
      {/* Mobile Menu Button */}
      <div className="flex items-center space-x-4 lg:hidden">
        {/* Mobile menu button */}
        <BurgerMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <MobileMenuLinks setIsMenuOpen={setIsMenuOpen} />}
    </nav>
  );
}
